export default "__VITE_ASSET__PuaDleCc__"